import { AppTable } from "src/component"
import { borrowerListData, borrowerListColumns } from "src/utils/tableLayout"
import { IoChevronBackOutline } from "react-icons/io5"
import { AppLabel, AppText, CustomContainer, FlexRow, GridContainer } from "src/style"
import { moneyFormat } from "src/utils/utility"

export const LendingDetails: React.FC<any> = ({data, back}) => {
    
    return (
        <CustomContainer>
            <FlexRow topMargin="2.5">
                <GridContainer 
                    height='3' width='3.2' borderColor=' #E4ECF7' 
                    radius='0.4' rightMargin='2'
                    onClick={back}
                >
                    <IoChevronBackOutline className='back-icon' />
                </GridContainer>
                <AppText textSize="1.8" fontWeight="700" color="#27272E">Portfolio Details</AppText>
            </FlexRow>
            <CustomContainer rightPadding="2" leftPadding="2">
                <FlexRow gap="3.5" topMargin="4" wrap="wrap">
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Loan Type</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.loanTypeName}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Amount</AppLabel>
                        <AppText textSize="1.2" color="#101225">₦{moneyFormat(data?.amount)}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Borrowers</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.numberOfBorrowers}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Amount per person</AppLabel>
                        <AppText textSize="1.2" color="#101225">₦{moneyFormat(data?.amountPerPerson)}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Tenor</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.tenor} {data?.tenorType}(s)</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Interest rate</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.interest}(%)</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Repayment</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data.rateName === 'FLAT' ? 'One-Off' : 'Installment'}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Frequency</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.repaymentTermName} repayment</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Negotiation</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.isNegotiable ? 'Yes' : 'No'}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Extension</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.isExtensionAllowed ? 'Yes': 'No'}</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Extension time</AppLabel>
                        <AppText textSize="1.2" color="#101225">{data?.canBeExtendedBy} days</AppText>
                    </CustomContainer>
                    <CustomContainer width="21" sizeUnit="%">
                        <AppLabel textSize="1.2" color="#718096">Loan Status</AppLabel>
                        <AppText textSize="1.2" color="#D46A51">{data?.completed ? 'Repaid' : data?.taken ? 'Running' : 'Open'}</AppText>
                    </CustomContainer>
                </FlexRow>
                <CustomContainer topMargin="3.5" overflow="auto" width="57.3" className="lending-description-wrapper">
                    <AppLabel textSize="1.2" color="#718096">Description</AppLabel>
                    <AppText textSize="1.2" color="#101225" >
                        {data?.about}
                    </AppText>
                </CustomContainer>
                <CustomContainer topMargin="4">
                    <AppLabel textSize="1.6" fontWeight="600" color="#27272E" bottomMargin="2">Borrower list</AppLabel>
                    <AppTable 
                        data={data?.borrowers}
                        columns={borrowerListColumns}
                    />
                </CustomContainer>
            </CustomContainer>
        </CustomContainer>
    )
}